import type { Store } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import auth from './services/auth.service';
import { baseApi } from './services/base.service';

let storeConfig: Store;

export const store = (token: string) => {
  storeConfig = configureStore({
    reducer: { ...reducers, auth },
    preloadedState: { auth: { token } },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
  });

  return storeConfig;
};

export type AppDispatch = typeof storeConfig.dispatch;
export type RootState = ReturnType<typeof storeConfig.getState>;
